import { AxiosError } from "axios";
import { BackendError } from "../../interfaces/error.interfaces";

export const getError = (error: AxiosError): BackendError => {
    if (error.response?.data) {
        const { message, code, description } = error.response
            .data as Partial<BackendError>;

        return {
            message: message || "An error occurred",
            code: code || 500,
            description: description || "No further details available",
        };
    }

    return {
        message: "Unknown error occurred",
        code: 100,
        description: "-",
    };
};

export interface ApiError extends Error {
    response?: {
        errorCode?: string;
        data?: {
            errorKey?: string;
            message?: string;
            errorCode?: string;
        };
    };
}

export const extractError = (error: ApiError | Error, defaultMessageKey: string): string => {
    const err = error as ApiError;

    return err.response?.errorCode ||
        err.response?.data?.errorKey ||
        err.response?.data?.errorCode ||
        err.response?.data?.message ||
        err.message ||
        defaultMessageKey;
};